export const normalizeAccountRole = (role) => {
  const normalizedRole = String(role || '').trim().toLowerCase();
  if (normalizedRole === 'vendor') return 'vendeur';
  if (normalizedRole === 'courier') return 'livreur';
  if (normalizedRole === 'affiliate') return 'ambassador';
  return normalizedRole;
};

export const resolveAccountBackPath = (role) => {
  const normalizedRole = normalizeAccountRole(role);
  if (normalizedRole === 'vendeur') return '/vendeur';
  if (normalizedRole === 'livreur') return '/livreur';
  if (normalizedRole === 'agent_pr') return '/agent-pr';
  if (normalizedRole === 'ambassador' || normalizedRole === 'super_ambassador') return '/affiliate/dashboard';
  if (normalizedRole === 'admin') return '/admin';
  return '/';
};

export const resolveAccountBackLabel = (role) => {
  const normalizedRole = normalizeAccountRole(role);
  if (normalizedRole === 'vendeur') return 'Retour vendeur';
  if (normalizedRole === 'livreur') return 'Retour livreur';
  if (normalizedRole === 'agent_pr') return 'Retour agent P-R';
  if (normalizedRole === 'ambassador' || normalizedRole === 'super_ambassador') return 'Retour affiliation';
  if (normalizedRole === 'admin') return 'Retour administration';
  return 'Retour';
};

export const formatAccountRoleLabel = (role) => {
  const normalizedRole = normalizeAccountRole(role);
  if (normalizedRole === 'vendeur') return 'Vendeur';
  if (normalizedRole === 'livreur') return 'Livreur';
  if (normalizedRole === 'admin') return 'Administrateur';
  if (normalizedRole === 'ambassador') return 'Ambassadeur';
  if (normalizedRole === 'super_ambassador') return 'Super ambassadeur';
  if (normalizedRole === 'agent_pr') return 'Agent P-R';
  return String(role || 'Utilisateur').trim() || 'Utilisateur';
};
